import { Stack, SxProps, Theme } from "@mui/material";
import { FC, memo, ReactNode } from "react";

type Props = {
  label: string | ReactNode;
  unit?: string;
  sx?: SxProps<Theme>;
};

const Parameter: FC<Props> = ({ label, unit = "", sx = {} }) => (
  <Stack direction="row" alignItems="center" justifyContent="space-between" sx={sx}>
    <span>{label}</span>
    {unit && <span>{unit}</span>}
  </Stack>
);

Parameter.displayName = "Parameter";

export default memo(Parameter);
